import axios from "axios";

import { getHeaderAuthTokenValue, getSessionAuthToken } from "src/msal";
import { IPublicClientApplication } from "@azure/msal-browser";

const logoutFromBackEnd = async (authToken: string) => {
  await axios
    .post("/api/logout", null, {
      headers: {
        authorization: getHeaderAuthTokenValue(authToken)
      },
      responseType: "json",
      baseURL: window.location.origin
    })
    .catch(() => null);
};

const getAuthToken = async (): Promise<string> => {
  let authToken: string;

  try {
    authToken = await getSessionAuthToken({
      asBearer: false,
      withRedirect: false
    });
  } catch (e) {
    authToken = "";
  }

  return authToken;
};

export const logout = async (instance: IPublicClientApplication) => {
  const authToken = await getAuthToken();

  await logoutFromBackEnd(authToken);
  await instance.logout({ idTokenHint: authToken });
};
